import { Field, FieldProps } from 'formik'
import { LabeledSelect, LabeledSelectProps } from '../Select/LabeledSelect'

const FormikSelect = (props: LabeledSelectProps & { name: string }) => {
  return (
    <Field name={props.name}>
      {({ meta, form, field }: FieldProps) => {
        const { setFieldValue } = form

        return (
          <LabeledSelect
            isInvalid={meta.error}
            onChange={(value) => {
              setFieldValue(props.name, value)
            }}
            value={meta.value}
            {...props}
            {...field}
          />
        )
      }}
    </Field>
  )
}

export default FormikSelect
